import { horizontalLoop } from '../../../src/js/utils/seamlessLoop'

function whatsHappening() {
    function awardsList() {
        const list = document.querySelector('[data-target="awards-list"]')

        if (list) {
            const listItems = list.querySelectorAll('.box-awards')
            const horizontal = horizontalLoop(listItems, { repeat: -1 })

            horizontal.play()

            list.addEventListener('mouseenter', () => {
                horizontal.pause()
            })

            list.addEventListener('mouseleave', () => {
                horizontal.play()
            })
        }
    }

    awardsList()
}

export default whatsHappening
